import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Faxes from '../views/Faxes.vue'
import Profile from "../views/Profile.vue";
import About from "../views/About.vue"
import { authGuard } from "../auth";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // beforeEnter: authGuard
  },
  {
    path: '/faxes',
    name: 'Faxes',
    component: Faxes,
    beforeEnter: authGuard
    //component: () => import("../components/Faxeslist")
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    beforeEnter: authGuard
  },
  {
    path: "/about",
    name: "About",
    component: About,
    beforeEnter: authGuard
  }
]

const router = new VueRouter({
  mode: "history",
  routes
})

export default router
